import type { FaireProductEntity } from "../../entity_types/product";

export const nopalera_7: FaireProductEntity = {
  token: "nopalera-7",
  type: "product",
  name: "Hibiscus Cactus Body Polish",
  brandName: "Nopalera",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/81e61382f9157e0e28a8c44c69ac1859d7a16c4524e699b09c8a4d39c773bdf5.webp",
  priceDollars: 26,
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.prerelease.faire.dev/fastly/81e61382f9157e0e28a8c44c69ac1859d7a16c4524e699b09c8a4d39c773bdf5.webp",
  weight: 0.6,
  dimensions: {
    width: 3,
    height: 5,
    depth: 2,
  },
  description: "Hibiscus cactus body polish - Nopalera bestseller",
  categoryTokens: ["cat_bath-all"],
  tags: ["premium", "organic", "bestseller", "body-polish"],
  inStock: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "legacy-compass-migration",
  },
};
